/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GetLicenseContactTypes = require('../services/GetLicenseContactTypes');
var GetCreditServicesLoanBrokerApplication = require('../services/GetCreditServicesLoanBrokerApplication');
var GetLicenseContactTypesByApplicationType = require('../services/GetLicenseContactTypesByApplicationType');
var GetLicenseContactsAndOfficersByEntity = require('../../common/services/GetLicenseContactsAndOfficersByEntity');
var GetApplicationDBAs = require('../services/GetApplicationDBAs');

var CreditServicesLoanBrokerApplication = require('../forms/CreditServicesLoanBrokerLicenseApplication');

module.exports = {
  event: 'build:license-new:credit-services-loan-broker',

  channel: 'nd:application',

  builder: function(config) {
    var defer = $.Deferred();

    $.when(
      GetLicenseContactTypes(),
      GetCreditServicesLoanBrokerApplication(config.applicationId),
      GetLicenseContactTypesByApplicationType(config.applicationTypeId),
      GetLicenseContactsAndOfficersByEntity(config.entityId),
      GetApplicationDBAs(config.applicationId)
    ).done(function(licenseContactTypes, applicationContent, requiredLicenseContactTypes, existingContacts, dbas) {
      var creditServicesApplication = new CreditServicesLoanBrokerApplication({
        isReadOnly: config.isReadOnly,
        mode: config.mode || 'new', // new, resubmit, print or int-expand
        model: new Backbone.Model({
          applicationId: config.applicationId,
          licenseContactTypes: licenseContactTypes,
          applicationContent: applicationContent,
          existingContacts: existingContacts,
          requiredLicenseContactTypes: requiredLicenseContactTypes,
          entityDBAs: dbas.entityDBAs,
          applicationDBAs: dbas.appDBAs
        })
      });
      defer.resolve(creditServicesApplication);
    });
    return defer.promise();
  }
};
